/**
 * The application entry point.
 *
 * This is what app/layout.tsx used to be. Next.js owned the document and rendered `<html>`/`<body>`
 * from a React component; a Vite SPA does not, so the document lives in index.html and this file
 * mounts into it.
 *
 * The providers are NOT here. They sit inside the route tree, in app/Root.tsx, because
 * SessionProvider calls useNavigate() and React Router's hooks need the router above them.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

// Mona Sans, SELF-HOSTED. UF_00 section 3.2 names it as the identity typeface.
//
// Self-hosted rather than pulled from Google Fonts, and that is a privacy decision, not a performance
// one: a font loaded from a third party sends every visitor's IP address to that third party on every
// page view. Under the Data Protection Act that is a transfer we would have to justify, for a font.
import '@fontsource-variable/mona-sans';

import { router } from './app/router';
import './app/globals.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element missing from index.html.');

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
